export const splitTrouserSizes = (
  sizeOptions: { value: string; inStock: boolean }[],
) => {
  let waistSizeOptions: { value: string; inStock: boolean }[] | null;

  let legSizeOptions: { value: string; inStock: boolean }[] | null;

  const trouserSizeOptions =
    sizeOptions &&
    sizeOptions[0].value &&
    sizeOptions[0].value.match(/(W){1}\d{2}(L)\d{2}/g)
      ? sizeOptions.map(sizeOption => {
          const [waist, leg] = sizeOption.value
            .split("L")
            .map(size => (size.startsWith("W") ? size.substring(1) : size));
          return {
            waist,
            leg,
            ...sizeOption,
          };
        })
      : null;

  if (trouserSizeOptions) {
    waistSizeOptions = trouserSizeOptions
      .map(option => {
        return {
          value: option.waist,
          inStock: trouserSizeOptions
            .filter(to => to.waist === option.waist)
            .some(e => e.inStock === true),
        };
      })
      .reduce((unique, o) => {
        if (
          !unique.some(
            obj => obj.value === o.value && obj.inStock === o.inStock,
          )
        ) {
          unique.push(o);
        }
        return unique;
      }, []);

    legSizeOptions = trouserSizeOptions
      .map(option => {
        return {
          value: option.leg,
          inStock: trouserSizeOptions
            .filter(to => to.leg === option.leg)
            .some(e => e.inStock === true),
        };
      })
      .reduce((unique, o) => {
        if (
          !unique.some(
            obj => obj.value === o.value && obj.inStock === o.inStock,
          )
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
  }

  return { trouserSizeOptions, waistSizeOptions, legSizeOptions };
};
